/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies,
  no-void,
  react/no-string-refs,
  react/prop-types
*/
import React from 'react';
import PropTypes from 'prop-types';
import setInterval from 'common/utils/set-interval';
import createReactClass from 'create-react-class';

const Fixed = createReactClass({

  propTypes: {
    app: PropTypes.object.isRequired, // Application
    absolute: PropTypes.bool, // Absolute positioning
  },

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
    this.onScroll();

    // fix issue with mobile chrome
    this._timer = setInterval(this.onScroll, 500);
  },

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    clearInterval(this._timer);
  },

  onScroll() {

    const headerElement = this.refs.header;
    if (!headerElement) {
      return;
    }

    const state = Object.assign({}, this.state);

    state.headerHeight = headerElement.offsetHeight;

    const isMobile = this.props.app.isMobile;

    if (isMobile || this.props.absolute) {
      state.style.position = 'absolute';
      state.style.top = window.pageYOffset;
    } else {
      state.style.position = 'fixed';
      state.style.top = 0;
    }

    this.setState(state);
  },

  getInitialState() {
    return {
      style: {
        width: '100%',
        zIndex: 1024,
        transition: '0.25s',
      },
    };
  },

  render() {
    const style = Object.assign({}, this.state.style);
    const headerHeight = this.state.headerHeight;
    return (
      <div>
        {this.state.style.position !== 'relative' ? <div style={{ height: headerHeight }}></div> : void 0 }
        <div className='m-fixed-container' ref='header' style={style}>
          { this.props.children }
        </div>
      </div>
    );
  },
});

module.exports = Fixed;
